import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { initMstSentryScope, MstSentry } from '@zillow/mst-sentry';
import getUserCookiePreferences from '@zillow/onetrust-cookie-parser';
import { getInventoryKeys } from '@zillow/mst-ad-slot-manager';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var name = "@zillow/mst-display-ad";
var version$1 = "0.1.7";
var description = "A library for fetching and rendering Ads on zillow properties";
var main = "./dist/mst-display-ad.cjs.js";
var module = "./dist/mst-display-ad.esm.js";
var files = ["dist"];
var scripts = {
  prepare: "npm run build",
  "build-dev": "NODE_ENV=dev znpm-scripts build --bundle",
  build: "NODE_ENV=prod znpm-scripts build --bundle",
  format: "znpm-scripts format",
  lint: "znpm-scripts lint",
  test: "znpm-scripts test --coverage",
  "test:watch": "znpm-scripts test",
  "test:update": "znpm-scripts test --updateSnapshot",
  validate: "znpm-scripts validate",
  "storybook:build": "build-storybook -c .storybook -o .out",
  storybook: "start-storybook -p 6006",
  "build-storybook": "build-storybook",
  "pretest:integration:ci": "npm run build",
  "test:integration:ci": "start-server-and-test start http://localhost:8000 test:integration",
  prepublishOnly: "echo \"npm publish invoked, be cautious if it is on your local machine\"",
  "asphalt-publish": "asphalt publish",
  watch: "znpm-scripts build --bundle --watch"
};
var husky = {
  hooks: {
    "pre-commit": "znpm-scripts pre-commit"
  }
};
var prettier = "@zillow/znpm-scripts/prettier";
var eslintConfig = {
  "extends": "./node_modules/@zillow/znpm-scripts/eslint"
};
var repository = {
  type: "git",
  url: "git@gitlab.zgtools.net:media-solutions-technology/mst-components/project-arcane.git"
};
var keywords = ["adverts", "component", "mst", "ads", "react"];
var author = "Media Solutions Team";
var license = "ISC";
var devDependencies = {
  "@babel/core": "^7.13.8",
  "@babel/plugin-proposal-optional-chaining": "^7.21.0",
  "@babel/plugin-proposal-private-property-in-object": "^7.21.11",
  "@sentry/react": "^7.119.0",
  "@sentry/rollup-plugin": "^2.22.6",
  "@storybook/addon-actions": "^6.3.4",
  "@storybook/addon-docs": "6.3.4",
  "@storybook/addon-essentials": "^6.3.4",
  "@storybook/addon-links": "^6.3.4",
  "@storybook/react": "^6.3.4",
  "@storybook/testing-library": "0.0.11",
  "@testing-library/jest-dom": "^4.2.4",
  "@testing-library/react": "^9.4.0",
  "@zillow/asphalt-cli": "^1.6.0",
  "@zillow/znpm-scripts": "^4.4.0",
  "babel-loader": "^8.2.2",
  "file-system-cache": "1.0.5",
  jest: "^24.9.0",
  "jest-canvas-mock": "^2.3.0",
  "jest-environment-jsdom-fifteen": "^1.0.2",
  "jest-environment-jsdom-global": "^2.0.4",
  "pre-commit": "^1.2.2",
  prettier: "^1.19.1",
  react: "^16.14.0",
  "react-dom": "^16.14.0"
};
var peerDependencies = {
  "@sentry/react": ">=7.119.0",
  "prop-types": "^15.6.2",
  react: "^16",
  "react-dom": "^16"
};
var publishConfig = {
  registry: "https://artifactory.zgtools.net/artifactory/api/npm/znpm"
};
var sideEffects = false;
var asphalt = {
  type: "library"
};
var dependencies = {
  "@zillow/mst-ad-slot-manager": "^1.1.1",
  "@zillow/mst-sentry": "^1.0.5",
  "@zillow/onetrust-cookie-parser": "^2.1.2",
  uuid: "^3.2.1"
};
var pjson = {
  name: name,
  version: version$1,
  description: description,
  main: main,
  module: module,
  files: files,
  scripts: scripts,
  husky: husky,
  prettier: prettier,
  eslintConfig: eslintConfig,
  repository: repository,
  keywords: keywords,
  author: author,
  license: license,
  devDependencies: devDependencies,
  peerDependencies: peerDependencies,
  publishConfig: publishConfig,
  sideEffects: sideEffects,
  asphalt: asphalt,
  dependencies: dependencies
};

var Arcane = /*#__PURE__*/function () {
  function Arcane() {
    this.mst = {
      headerBiddingSlots: {},
      nonHeaderBiddingSlots: {},
      adSlotsDict: {},
      deferredDict: {}
    };
  }
  var _proto = Arcane.prototype;
  _proto.getAnySlotById = function getAnySlotById(slotId) {
    if (this.mst.adSlotsDict[slotId]) {
      return this.mst.adSlotsDict[slotId].slot;
    }
    if (this.mst.headerBiddingSlots[slotId]) {
      return this.mst.headerBiddingSlots[slotId].slot;
    }
    if (this.mst.deferredDict[slotId]) {
      return this.mst.deferredDict[slotId];
    }
    if (this.mst.nonHeaderBiddingSlots[slotId]) {
      return this.mst.nonHeaderBiddingSlots[slotId];
    }
    return null;
  };
  _proto.setHeaderBiddingSlotById = function setHeaderBiddingSlotById(slotId, definedSlot) {
    this.mst.headerBiddingSlots[slotId] = {
      slot: definedSlot,
      requestSent: false
    };
  };
  _proto.getHeaderBiddingSlotById = function getHeaderBiddingSlotById(slotId) {
    if (this.mst.headerBiddingSlots[slotId]) {
      return this.mst.headerBiddingSlots[slotId];
    }
    return null;
  };
  _proto.getAllHeaderBiddingSlots = function getAllHeaderBiddingSlots() {
    return Object.values(this.mst.headerBiddingSlots);
  };
  _proto.setNonHeaderBiddingSlotById = function setNonHeaderBiddingSlotById(slotId, definedSlot) {
    this.mst.nonHeaderBiddingSlots[slotId] = definedSlot;
  };
  _proto.getNonHeaderBiddingSlotById = function getNonHeaderBiddingSlotById(slotId) {
    if (this.mst.nonHeaderBiddingSlots[slotId]) {
      return this.mst.nonHeaderBiddingSlots[slotId];
    }
    return null;
  };
  _proto.getAllNonHeaderBiddingSlots = function getAllNonHeaderBiddingSlots() {
    return Object.values(this.mst.nonHeaderBiddingSlots);
  };
  _proto.setAdSlot = function setAdSlot(slotId, definedSlot) {
    this.mst.adSlotsDict[slotId] = {
      slot: definedSlot,
      requestSent: false
    };
  };
  _proto.getAdSlotById = function getAdSlotById(slotId) {
    if (this.mst.adSlotsDict[slotId]) {
      return this.mst.adSlotsDict[slotId];
    }
    return null;
  };
  _proto.getAllAdSlots = function getAllAdSlots() {
    return Object.values(this.mst.adSlotsDict);
  };
  _proto.deleteAdSlotById = function deleteAdSlotById(slotId) {
    if (this.mst.adSlotsDict[slotId]) {
      delete this.mst.adSlotsDict[slotId];
    }
  };
  _proto.deleteNonHeaderBiddingAdSlotById = function deleteNonHeaderBiddingAdSlotById(slotId) {
    if (this.mst.nonHeaderBiddingSlots[slotId]) {
      delete this.mst.nonHeaderBiddingSlots[slotId];
    }
  };
  _proto.deleteDeferredAdSlotById = function deleteDeferredAdSlotById(slotId) {
    if (this.mst.deferredDict[slotId]) {
      delete this.mst.deferredDict[slotId];
    }
  };
  _proto.deleteHeaderBiddingAdSlotById = function deleteHeaderBiddingAdSlotById(slotId) {
    if (this.mst.headerBiddingSlots[slotId]) {
      delete this.mst.headerBiddingSlots[slotId];
    }
  };
  _proto.setDeferredSlotById = function setDeferredSlotById(slotId, definedSlot) {
    this.mst.deferredDict[slotId] = definedSlot;
  };
  _proto.getDeferredSlotById = function getDeferredSlotById(slotId) {
    if (this.mst.deferredDict[slotId]) {
      return this.mst.deferredDict[slotId];
    }
    return null;
  };
  _proto.getAllDeferredSlots = function getAllDeferredSlots() {
    return Object.values(this.mst.deferredDict);
  };
  _proto.setSentryScope = function setSentryScope(scope) {
    this.mst.sentryScope = scope;
  };
  _proto.captureException = function captureException(error) {
    var _this$mst$sentryScope;
    console.error(error);
    (_this$mst$sentryScope = this.mst.sentryScope) === null || _this$mst$sentryScope === void 0 ? void 0 : _this$mst$sentryScope.captureException(error);
  }

  // function used in tests to make sure that we don't carry over arcane slots between tests.
  ;
  _proto.clearAllSlots = function clearAllSlots() {
    var removeAllKeys = function removeAllKeys(obj) {
      var keys = Object.keys(obj);
      keys.forEach(function (key) {
        if (obj[key]) {
          delete obj[key];
        }
      });
    };
    removeAllKeys(this.mst.adSlotsDict);
    removeAllKeys(this.mst.deferredDict);
    removeAllKeys(this.mst.headerBiddingSlots);
    removeAllKeys(this.mst.nonHeaderBiddingSlots);
  };
  return Arcane;
}();
var arcane = new Arcane();
var arcane$1 = arcane;

function setTarget(targets, slot) {
  Object.entries(targets).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    slot === null || slot === void 0 ? void 0 : slot.setTargeting(k, v);
  });
}
function getAdZone(_ref3) {
  var device = _ref3.device,
    position = _ref3.position,
    path = _ref3.path,
    _ref3$provider = _ref3.provider,
    provider = _ref3$provider === void 0 ? {
      name: 'zillow',
      id: 7449
    } : _ref3$provider,
    _ref3$pageType = _ref3.pageType,
    pageType = _ref3$pageType === void 0 ? 'connectivity' : _ref3$pageType,
    _ref3$brand = _ref3.brand,
    brand = _ref3$brand === void 0 ? 'marketplace' : _ref3$brand,
    isRestricted = _ref3.isRestricted,
    restrictionOverride = _ref3.restrictionOverride;
  var SUPPORTED_DEVICES = ['desktop', 'tablet', 'mobile'];
  var deviceMap = {
    mobile: '_phone_mweb',
    tablet: '_tablet_mweb',
    desktop: ''
  };
  var slotMap = {
    mobile: '_mweb_phone',
    tablet: '_mweb_tablet',
    desktop: ''
  };
  var pos = setRestrictionOnPath({
    position: position,
    isRestricted: isRestricted,
    restrictionOverride: restrictionOverride
  });
  var deviceType = SUPPORTED_DEVICES.includes(device) ? device : 'desktop';
  var deviceAttr = deviceMap[deviceType];
  var id = provider.id,
    name = provider.name;
  var adZone = path || ("/" + id + "/" + name + deviceAttr + "/" + brand + "/" + pageType + "/" + pos).trim();
  var slotAttr = slotMap[deviceType];
  return {
    adZone: adZone,
    slotAttr: slotAttr
  };
}
function isObjEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function capitalize(s) {
  return s[0].toUpperCase() + s.slice(1);
}
function setRestrictionOnPath(_ref4) {
  var position = _ref4.position,
    isRestricted = _ref4.isRestricted,
    restrictionOverride = _ref4.restrictionOverride;
  if (restrictionOverride) {
    var pos = position.replace('_restricted', '');
    return pos;
  }
  if (isRestricted) {
    var _pos = position + "_restricted";
    return _pos;
  }
  return position;
}

/**
 * Retries a given function with a specified number of attempts and delay.
 *
 * @param {function} fn - The function to be retried.
 * @param {object} options - Options for the retry behavior.
 * @param {number} [options.maxAttempts=16] - The maximum number of attempts.
 * @param {number} [options.delay=50] - The delay between attempts in milliseconds.
 * @return {Promise} A promise that resolves when the function is successful, or rejects when the maximum attempts are reached.
 */
function retry(fn, _temp) {
  var _ref5 = _temp === void 0 ? {} : _temp,
    _ref5$maxAttempts = _ref5.maxAttempts,
    maxAttempts = _ref5$maxAttempts === void 0 ? 16 : _ref5$maxAttempts,
    _ref5$delay = _ref5.delay,
    delay = _ref5$delay === void 0 ? 50 : _ref5$delay;
  var attempts = 0;
  return new Promise(function (resolve, reject) {
    function inner() {
      return new Promise(function ($return, $error) {
        var result;
        return Promise.resolve(fn()).then(function ($await_1) {
          try {
            result = $await_1;
            if (attempts >= maxAttempts) {
              reject(new Error("Max attempts (" + maxAttempts + ") reached"));
            } else if (result) {
              resolve(result);
            } else {
              attempts += 1;
              setTimeout(inner, delay);
            }
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }
    inner();
  });
}
function hasSlotId(slotList, slotId) {
  var lists = new Set(slotList);
  return lists.has(slotId);
}
function refreshAdSlot() {
  var slotMap = Object.keys(arcane$1.getAllAdSlots()).map(function (s) {
    return arcane$1.getAllAdSlots()[s];
  });
  var slotDict = slotMap.filter(function (s) {
    return !s.requestSent;
  });
  if (slotDict.length === 0) {
    return;
  }
  slotDict.forEach(function (s) {
    s.requestSent = true;
  });
  var slot = slotDict.map(function (s) {
    return s.slot;
  });
  gtag.cmd.push(function () {
    return gtag.pubads().refresh(slot, {
      changeCorrelator: false
    });
  });
}

var eventHandlers = {};

/**
 * Removes a callback from the event handler
 */
function removeEventListener$1(eventName, callback) {
  try {
    var _eventHandlers$eventN2;
    if (eventHandlers !== null && eventHandlers !== void 0 && (_eventHandlers$eventN2 = eventHandlers[eventName]) !== null && _eventHandlers$eventN2 !== void 0 && _eventHandlers$eventN2.callbacks) {
      var index = eventHandlers[eventName].callbacks.indexOf(callback);
      if (index > -1) {
        eventHandlers[eventName].callbacks.splice(index, 1);
      }
    }
  } catch (error) {
    arcane$1.captureException(error);
  }
}
function capEventName(event) {
  var capName = capitalize(event);
  var callbackFunc = "on" + capName;
  return callbackFunc;
}
function registerEvents(eventList, props) {
  if (props === void 0) {
    props = {};
  }
  eventList === null || eventList === void 0 ? void 0 : eventList.forEach(function (event) {
    var callback = capEventName(event);
    if (gtag.pubads && props[callback]) {
      var _gtag2, _gtag2$pubads;
      (_gtag2 = gtag) === null || _gtag2 === void 0 ? void 0 : (_gtag2$pubads = _gtag2.pubads()) === null || _gtag2$pubads === void 0 ? void 0 : _gtag2$pubads.addEventListener(event, props[callback]);
    }
  });
}
function unRegisterEvents(eventList, props) {
  var _window;
  if (props === void 0) {
    props = {};
  }
  if ((_window = window) !== null && _window !== void 0 && _window.gtag) {
    eventList === null || eventList === void 0 ? void 0 : eventList.forEach(function (event) {
      var _gtag$pubads;
      var callback = capEventName(event);
      if (gtag.pubads && props[callback] && typeof ((_gtag$pubads = gtag.pubads()) === null || _gtag$pubads === void 0 ? void 0 : _gtag$pubads.removeEventListener) === 'function') {
        gtag.pubads().removeEventListener(event, props[callback]);
      }
    });
  }
}

/* global gtag */
var SAFE_FRAME_CONFIG = {
  sandbox: true,
  allowOverlayExpansion: false,
  allowPushExpansion: false
};
function isGPTtagReady() {
  return new Promise(function ($return, $error) {
    var _window, isReady;
    isReady = false;
    if ((_window = window) !== null && _window !== void 0 && _window.gtag) {
      return Promise.resolve(gtag && gtag.apiReady).then(function ($await_2) {
        try {
          isReady = $await_2;
          return $return(isReady);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    }
    return $return(isReady);
  });
}
function initializeGlobals() {
  return new Promise(function ($return, $error) {
    if (typeof window !== 'undefined') {
      window.googletag = window.googletag || {
        cmd: []
      };
      window.gtag = window.gtag || window.googletag;
      window.mst = window.mst || {
        adSlotsDict: {},
        deferredDict: {}
      };
    }
    return $return();
  });
}
function configurePublisherAdsService(isSRA) {
  var _getUserCookiePrefere = getUserCookiePreferences(),
    isAdvertisingCookieBlocked = _getUserCookiePrefere.isAdvertisingCookieBlocked;
  if (gtag.pubads) {
    gtag.pubads().disableInitialLoad();
    if (isSRA) {
      gtag.pubads().enableSingleRequest();
    }
    gtag.pubads().setPrivacySettings({
      restrictDataProcessing: !!isAdvertisingCookieBlocked
    });
    gtag.pubads().setSafeFrameConfig(SAFE_FRAME_CONFIG);
    gtag.enableServices();
  }
}
function createSlot(slot, _ref) {
  var _gtag;
  var targets = _ref.targets,
    ppid = _ref.ppid,
    isSRA = _ref.isSRA;
  if (typeof ((_gtag = gtag) === null || _gtag === void 0 ? void 0 : _gtag.setConfig) === 'function') {
    gtag.setConfig({
      threadYield: 'ENABLED_ALL_SLOTS'
    });
  }
  if (targets) {
    var mainTargets = Object.assign({}, targets, {
      package: "mst_" + pjson.version + "v"
    });
    setTarget(mainTargets, slot);
  }
  if (ppid) {
    gtag.pubads().setPublisherProvidedId(ppid);
  }
  configurePublisherAdsService(isSRA);
}
function defineAdSlot(_ref2) {
  var adZone = _ref2.adZone,
    adSizes = _ref2.adSizes,
    targetDiv = _ref2.targetDiv,
    _ref2$collapseAfterRe = _ref2.collapseAfterRequest,
    collapseAfterRequest = _ref2$collapseAfterRe === void 0 ? true : _ref2$collapseAfterRe,
    _ref2$collapseBeforeR = _ref2.collapseBeforeRequest,
    collapseBeforeRequest = _ref2$collapseBeforeR === void 0 ? false : _ref2$collapseBeforeR;
  return gtag.defineSlot(adZone, adSizes, targetDiv).addService(gtag.pubads()).setCollapseEmptyDiv(collapseAfterRequest, collapseBeforeRequest);
}

var _excluded$2 = ["adInventory", "isPrebidAllowed", "gptReady", "eventList", "slotList", "adId", "isSRA", "pbjsReady"];
function getSlotKeys(_ref) {
  return new Promise(function ($return, $error) {
    var device, variant, setSlotList, keys;
    device = _ref.device, variant = _ref.variant, setSlotList = _ref.setSlotList;
    return Promise.resolve(getInventoryKeys(device, variant)).then(function ($await_4) {
      try {
        keys = $await_4;
        setSlotList(keys);
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}
function createSlotFromInventory(_ref2) {
  var adInventory = _ref2.adInventory;
    _ref2.isPrebidAllowed;
    var gptReady = _ref2.gptReady,
    eventList = _ref2.eventList,
    slotList = _ref2.slotList;
    _ref2.adId;
    var isSRA = _ref2.isSRA;
    _ref2.pbjsReady;
    var props = _objectWithoutProperties(_ref2, _excluded$2);
  var ppid = adInventory.ppid,
    pageType = adInventory.pageType,
    position = adInventory.position,
    path = adInventory.path,
    brand = adInventory.brand,
    device = adInventory.device,
    targetDiv = adInventory.targetDiv,
    adSizes = adInventory.adSizes,
    deferred = adInventory.deferred,
    targets = adInventory.targets,
    restrictionOverride = adInventory.restrictionOverride,
    isRestricted = adInventory.isRestricted,
    collapseAfterRequest = adInventory.collapseAfterRequest,
    collapseBeforeRequest = adInventory.collapseBeforeRequest;
  if (gptReady && !isObjEmpty(adInventory)) {
    if (slotList.length > 0) {
      gtag.cmd.push(function () {
        return new Promise(function ($return, $error) {
          var mockEvent, _getAdZone, adZone, existingSlot, definedSlot, _existingSlot, _definedSlot, deferredSlot;
          // Check if gtag has been modified by an ad blocker, such as ublock origin.
          if (typeof gtag.pubads !== 'function' || typeof gtag.pubads().isInitialLoadDisabled !== 'function') {
            mockEvent = {
              isEmpty: true,
              slot: {
                getAdUnitPath: function getAdUnitPath() {
                  return position !== null && position !== void 0 ? position : path;
                }
              }
            };
            props.onSlotRenderEnded(mockEvent);
            return $return();
          }
          if (hasSlotId(slotList, targetDiv)) {
            _getAdZone = getAdZone({
              device: device,
              position: position,
              path: path,
              pageType: pageType,
              brand: brand,
              restrictionOverride: restrictionOverride,
              isRestricted: isRestricted
            }), adZone = _getAdZone.adZone;
            if (!deferred && !arcane$1.getAdSlotById(targetDiv)) {
              existingSlot = arcane$1.getAnySlotById(targetDiv);
              if (existingSlot) {
                // this means there was a race condition on destroying the old slot
                // we will return to prevent execution of later code to prevent
                // defining a slot that already exists
                return $return();
              }
              definedSlot = gtag.defineSlot(adZone, adSizes, targetDiv).addService(gtag.pubads()).setCollapseEmptyDiv(collapseAfterRequest, collapseBeforeRequest);
              arcane$1.setAdSlot(targetDiv, definedSlot);
              createSlot(definedSlot, {
                targets: targets,
                eventList: eventList,
                props: props,
                ppid: ppid,
                isSRA: isSRA
              });
            } else if (deferred && !arcane$1.getDeferredSlotById(targetDiv)) {
              _existingSlot = arcane$1.getAnySlotById(targetDiv);
              if (_existingSlot) {
                // this means there was a race condition on destroying the old slot
                // we will return to prevent execution of later code to prevent
                // defining a slot that already exists
                return $return();
              }
              _definedSlot = arcane$1.getDeferredSlotById(targetDiv) || defineAdSlot({
                adZone: adZone,
                adSizes: adSizes,
                targetDiv: targetDiv,
                collapseAfterRequest: collapseAfterRequest,
                collapseBeforeRequest: collapseBeforeRequest
              });
              arcane$1.setDeferredSlotById(targetDiv, _definedSlot);
              createSlot(_definedSlot, {
                targets: targets,
                eventList: eventList,
                props: props,
                ppid: ppid,
                isSRA: isSRA
              });
            }
            if (!deferred && arcane$1.getAdSlotById(targetDiv)) {
              return Promise.resolve(gtag.cmd.push(function () {
                return gtag.display(targetDiv);
              })).then(function ($await_5) {
                try {
                  refreshAdSlot();
                  return $If_2.call(this);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }.bind(this), $error);
            } else {
              if (arcane$1.getDeferredSlotById(targetDiv)) {
                return Promise.resolve(arcane$1.getDeferredSlotById(targetDiv)).then(function ($await_6) {
                  try {
                    deferredSlot = arcane$1.getDeferredSlotById(targetDiv);
                    gtag.display(targetDiv);
                    return Promise.resolve(gtag.cmd.push(function () {
                      return gtag.pubads().refresh([deferredSlot], {
                        changeCorrelator: false
                      });
                    })).then(function ($await_7) {
                      try {
                        return $If_3.call(this);
                      } catch ($boundEx) {
                        return $error($boundEx);
                      }
                    }.bind(this), $error);
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }.bind(this), $error);
              }
              function $If_3() {
                return $If_2.call(this);
              }
              return $If_3.call(this);
            }
            function $If_2() {
              return $If_1.call(this);
            }
          }
          function $If_1() {
            return $return();
          }
          return $If_1.call(this);
        });
      });
    }
  }
}

/* global pbjs,gtag, mst */

/**
 * Initializes the Prebid library and sets up necessary global variables if they are not already defined.
 */
function initPrebid() {
  window.pbjs = window.pbjs || {
    que: []
  };
  window.mst = window.mst || {};
  window.mst.headerBiddingSlots = window.mst.headerBiddingSlots || {};
  window.mst.nonHeaderBiddingSlots = window.mst.nonHeaderBiddingSlots || {};
  window.mst.callbackObj = window.mst.callbackObj || {
    sendAdServerRequest: function sendAdServerRequest() {}
  };
}
/**
 * Check if the pbjs object is available and has the setConfig function.
 *
 * @return {boolean} True if pbjs is ready.
 */
function isPbjsReady() {
  var _window;
  return !!((_window = window) !== null && _window !== void 0 && _window.pbjs) && typeof pbjs.setConfig === 'function';
}
/**
 * Function to get the auction callback object and set up a function to send an ad server request.
 *
 * @return {Object} The auction callback object.
 */
function getAuctionCallback() {
  var _mst;
  if ((_mst = mst) !== null && _mst !== void 0 && _mst.callbackObj) {
    mst.callbackObj.sendAdServerRequest = function (newSlots) {
      var biddableSlots = arcane$1.getAllHeaderBiddingSlots().filter(function (slot) {
        return newSlots.includes(slot.slot) && !slot.requestSent;
      });
      if (biddableSlots.length === 0) {
        return;
      }
      biddableSlots.forEach(function (hbSlot) {
        hbSlot.requestSent = true;
      });
      gtag.pubads().refresh(biddableSlots.map(function (biddableSlot) {
        return biddableSlot.slot;
      }));
    };
    return mst.callbackObj;
  }
  return {};
}
function failOverGPT(gptSlots, timeout) {
  setTimeout(function () {
    // callAdserver(gptSlots);
    mst.callbackObj.sendAdServerRequest(gptSlots);
  }, timeout);
}
function callPrebid(_ref) {
  var gptSlotList = _ref.gptSlotList,
    _ref$sizeMappings = _ref.sizeMappings,
    sizeMappings = _ref$sizeMappings === void 0 ? {} : _ref$sizeMappings,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$failOverTimeout = _ref.failOverTimeout,
    failOverTimeout = _ref$failOverTimeout === void 0 ? 2000 : _ref$failOverTimeout;
  pbjs.que.push(function () {
    pbjs.rp.requestBids({
      callback: mst.callbackObj.sendAdServerRequest,
      gptSlotObjects: gptSlotList,
      // timeout: prebidTimeout,
      data: data,
      sizeMappings: sizeMappings
    });
  });
  failOverGPT(gptSlotList, failOverTimeout);
}

var _excluded$1 = ["adInventory", "isPrebidAllowed", "failOverTimeout", "gptReady", "eventList", "slotList", "adId", "isSRA", "pbjsReady"];
function createPrebidSlotFromInventory(_ref) {
  var adInventory = _ref.adInventory;
    _ref.isPrebidAllowed;
    var _ref$failOverTimeout = _ref.failOverTimeout,
    failOverTimeout = _ref$failOverTimeout === void 0 ? 2000 : _ref$failOverTimeout;
    _ref.gptReady;
    var eventList = _ref.eventList,
    _ref$slotList = _ref.slotList,
    slotList = _ref$slotList === void 0 ? [] : _ref$slotList;
    _ref.adId;
    var isSRA = _ref.isSRA;
    _ref.pbjsReady;
    var props = _objectWithoutProperties(_ref, _excluded$1);
  var ppid = adInventory.ppid,
    pageType = adInventory.pageType,
    position = adInventory.position,
    path = adInventory.path,
    brand = adInventory.brand,
    device = adInventory.device,
    targetDiv = adInventory.targetDiv,
    adSizes = adInventory.adSizes,
    deferred = adInventory.deferred,
    targets = adInventory.targets,
    restrictionOverride = adInventory.restrictionOverride,
    isRestricted = adInventory.isRestricted,
    collapseAfterRequest = adInventory.collapseAfterRequest,
    collapseBeforeRequest = adInventory.collapseBeforeRequest;
  if (!isObjEmpty(adInventory)) {
    if (slotList.length === 0) {
      return;
    }
    // block extra calls by gpt when prebid is allowed
    // gtag.cmd.push(() => gtag.pubads().disableInitialLoad());
    // make initial request before creating slot
    mst.callbackObj = getAuctionCallback();
    gtag.cmd.push(function () {
      return new Promise(function ($return, $error) {
        var mockEvent, _getAdZone, adZone, existingSlot, definedSlot, gptSlotList;
        if (typeof gtag.pubads !== 'function') {
          mockEvent = {
            isEmpty: true,
            slot: {
              getAdUnitPath: function getAdUnitPath() {
                return position !== null && position !== void 0 ? position : path;
              }
            }
          };
          props.onSlotRenderEnded(mockEvent);
          return $return();
        }
        if (hasSlotId(slotList, targetDiv)) {
          _getAdZone = getAdZone({
            device: device,
            position: position,
            path: path,
            pageType: pageType,
            brand: brand,
            restrictionOverride: restrictionOverride,
            isRestricted: isRestricted
          }), adZone = _getAdZone.adZone;
          if (!deferred && !arcane$1.getHeaderBiddingSlotById(targetDiv)) {
            existingSlot = arcane$1.getAnySlotById(targetDiv);
            if (existingSlot) {
              // this means there was a race condition on destroying the old slot
              // we will return to prevent execution of later code to prevent
              // defining a slot that already exists
              return $return();
            }
            definedSlot = gtag.defineSlot(adZone, adSizes, targetDiv).addService(gtag.pubads()).setCollapseEmptyDiv(collapseAfterRequest, collapseBeforeRequest);
            arcane$1.setHeaderBiddingSlotById(targetDiv, definedSlot);
            createSlot(definedSlot, {
              targets: targets,
              eventList: eventList,
              props: props,
              ppid: ppid,
              isSRA: isSRA
            });
          }
          return Promise.resolve(arcane$1.getHeaderBiddingSlotById(targetDiv)).then(function ($await_2) {
            try {
              gptSlotList = arcane$1.getAllHeaderBiddingSlots().map(function (slot) {
                return slot.slot;
              });
              callPrebid({
                gptSlotList: gptSlotList,
                failOverTimeout: failOverTimeout
              });
              return $If_1.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }
        function $If_1() {
          return $return();
        }
        return $If_1.call(this);
      });
    });
  }
}

/* global gtag, mst */
function refreshSlot$1(slotId, targets, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    failOverTimeout = _ref.failOverTimeout;
  try {
    var slotArray = [];
    if (slotId) {
      if (Array.isArray(slotId)) {
        var _gtag;
        slotId.forEach(function (slot) {
          var slotObj = arcane$1.getAdSlotById(slot);
          slotArray.push(slotObj);
          updateTarget(targets, slot);
        });
        (_gtag = gtag) === null || _gtag === void 0 ? void 0 : _gtag.pubads().refresh(slotArray, {
          changeCorrelator: false
        });
      } else if (arcane$1.getHeaderBiddingSlotById(slotId)) {
        updateTarget(targets, slotId);
        arcane$1.getHeaderBiddingSlotById(slotId).requestSent = false;
        mst.callbackObj = getAuctionCallback(null, slotId);
        var gptSlotList = arcane$1.getAllHeaderBiddingSlots().map(function (s) {
          return s.slot;
        });
        callPrebid({
          gptSlotList: gptSlotList,
          failOverTimeout: failOverTimeout
        });
      } else if (arcane$1.getAdSlotById(slotId)) {
        updateTarget(targets, slotId);
        arcane$1.getAdSlotById(slotId).requestSent = false;
        refreshAdSlot();
      }
    }
  } catch (error) {
    arcane$1.captureException(error);
  }
}
function clearSlotTargeting$1(slotId) {
  try {
    var _window;
    if (!slotId || !((_window = window) !== null && _window !== void 0 && _window.gtag)) {
      return;
    }
    var slot = arcane$1.getAnySlotById(slotId);
    slot === null || slot === void 0 ? void 0 : slot.clearTargeting();
  } catch (error) {
    arcane$1.captureException(error);
  }
}
function destroySlot$1(slotId) {
  try {
    if (slotId) {
      var _window2, _window3, _window3$gtag;
      if ((_window2 = window) !== null && _window2 !== void 0 && _window2.gtag && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$gtag = _window3.gtag) === null || _window3$gtag === void 0 ? void 0 : _window3$gtag.destroySlots) === 'function') {
        var _arcane$getAdSlotById, _arcane$getHeaderBidd;
        var slotToDestroy = ((_arcane$getAdSlotById = arcane$1.getAdSlotById(slotId)) === null || _arcane$getAdSlotById === void 0 ? void 0 : _arcane$getAdSlotById.slot) || arcane$1.getDeferredSlotById(slotId) || arcane$1.getNonHeaderBiddingSlotById(slotId) || ((_arcane$getHeaderBidd = arcane$1.getHeaderBiddingSlotById(slotId)) === null || _arcane$getHeaderBidd === void 0 ? void 0 : _arcane$getHeaderBidd.slot);
        if (slotToDestroy) {
          var _window4, _window4$gtag, _window5, _window5$gtag;
          // clear targeting from memory
          (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$gtag = _window4.gtag) === null || _window4$gtag === void 0 ? void 0 : _window4$gtag.pubads().clearTargeting();
          slotToDestroy === null || slotToDestroy === void 0 ? void 0 : slotToDestroy.clearTargeting();
          (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$gtag = _window5.gtag) === null || _window5$gtag === void 0 ? void 0 : _window5$gtag.destroySlots([slotToDestroy]);
          if (arcane$1.getAdSlotById(slotId)) {
            arcane$1.deleteAdSlotById(slotId);
          }
          if (arcane$1.getHeaderBiddingSlotById(slotId)) {
            arcane$1.deleteHeaderBiddingAdSlotById(slotId);
          }
          if (arcane$1.getDeferredSlotById(slotId)) {
            arcane$1.deleteDeferredAdSlotById(slotId);
          }
          if (arcane$1.getNonHeaderBiddingSlotById(slotId)) {
            arcane$1.deleteNonHeaderBiddingAdSlotById(slotId);
          }
        }
      }
    }
  } catch (error) {
    arcane$1.captureException(error);
  }
}
function updateTarget(targets, slotId) {
  clearSlotTargeting$1(slotId);
  if (targets && arcane$1.getAdSlotById(slotId)) {
    var mainTargets = Object.assign({}, targets, {
      package: "mst_" + pjson.version + "v"
    });
    setTarget(mainTargets, arcane$1.getAdSlotById(slotId).slot);
  }
  if (targets && arcane$1.getNonHeaderBiddingSlotById(slotId)) {
    var _mainTargets = Object.assign({}, targets, {
      package: "mst_" + pjson.version + "v"
    });
    setTarget(_mainTargets, arcane$1.getNonHeaderBiddingSlotById(slotId));
  }
  if (targets && arcane$1.getHeaderBiddingSlotById(slotId)) {
    var _mainTargets2 = Object.assign({}, targets, {
      package: "mst_" + pjson.version + "v"
    });
    setTarget(_mainTargets2, arcane$1.getHeaderBiddingSlotById(slotId).slot);
  }
  if (targets && arcane$1.getDeferredSlotById(slotId)) {
    var _mainTargets3 = Object.assign({}, targets, {
      package: "mst_" + pjson.version + "v"
    });
    setTarget(_mainTargets3, arcane$1.getDeferredSlotById(slotId));
  }
}
function setGoogleTag(slotId, isArray) {
  var _mst$deferredDict$slo;
  var meta = (_mst$deferredDict$slo = mst.deferredDict[slotId]) === null || _mst$deferredDict$slo === void 0 ? void 0 : _mst$deferredDict$slo.meta;
  var adZone = meta.adZone,
    adSizes = meta.adSizes,
    collapseAfterRequest = meta.collapseAfterRequest,
    collapseBeforeRequest = meta.collapseBeforeRequest,
    ppid = meta.ppid,
    targets = meta.targets;
  mst.adSlotsDict[slotId] = gtag.defineSlot(adZone, adSizes, meta === null || meta === void 0 ? void 0 : meta.adId).addService(gtag.pubads()).setCollapseEmptyDiv(collapseAfterRequest, collapseBeforeRequest);
  gtag.pubads().disableInitialLoad();
  configurePublisherAdsService();
  gtag.display(meta === null || meta === void 0 ? void 0 : meta.adId);
  updateTarget(targets, slotId);
  if (ppid) {
    gtag.pubads().setPublisherProvidedId(ppid);
  }
  if (!isArray) {
    var _gtag2;
    (_gtag2 = gtag) === null || _gtag2 === void 0 ? void 0 : _gtag2.pubads().refresh([mst.adSlotsDict[slotId]], {
      changeCorrelator: false
    });
  }
}
function refreshDeferredSlot$1(slotId) {
  try {
    var slotArray = [];
    if (slotId) {
      if (Array.isArray(slotId)) {
        var _gtag3;
        slotId.forEach(function (slot) {
          setGoogleTag(slot, true);
        });
        (_gtag3 = gtag) === null || _gtag3 === void 0 ? void 0 : _gtag3.pubads().refresh(slotArray, {
          changeCorrelator: false
        });
      } else {
        setGoogleTag(slotId);
      }
    }
  } catch (error) {
    arcane$1.captureException(error);
  }
}

var instance = {};
var GoogleGptScriptLoader = function GoogleGptScriptLoader(_url, _id) {
  var _this = this;
  this.injectScriptToHeaderTag = function (scriptUrl, id) {
    if (typeof window !== 'undefined' && !instance[id]) {
      var gpts = document.createElement('script');
      gpts.async = true;
      gpts.type = 'text/javascript';
      gpts.src = scriptUrl;
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(gpts);
    }
  };
  // Inject library script to page head
  this.loadGptScript = function (url, id) {
    _this.injectScriptToHeaderTag(url, id);
    return instance;
  };
  if (!instance[_id]) {
    this.loadGptScript(_url);
    instance[_id] = _url;
  }
};
var libInitLoader = function libInitLoader(url, id) {
  return new GoogleGptScriptLoader(url, id);
};
var libInitLoader$1 = libInitLoader;

var Slots = function Slots(_ref) {
  var className = _ref.className,
    targetDiv = _ref.targetDiv,
    alt = _ref.alt,
    allowtransparency = _ref.allowtransparency,
    adId = _ref.adId;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: targetDiv,
    "data-id": adId,
    alt: alt,
    // eslint-disable-next-line zillow/react/no-unknown-property
    allowtransparency: allowtransparency
  }, ' ');
};
Slots.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  alt: PropTypes.string,
  allowtransparency: PropTypes.string
} : {};
Slots.defaultProps = {
  className: '',
  alt: 'Advertisement',
  allowtransparency: 'false'
};
var Slots$1 = Slots;

var SENTRY_DNS = 'https://c52f66aed995ee8d1179a443082cf17a@o168728.ingest.us.sentry.io/4506990130167808';
var SENTRY_PROJECT_NAME = 'mst-ads';

var _excluded = ["pageType", "adInventory", "targetDiv", "targets", "eventList", "isSRA", "blockGptLib", "blockPrebidLib", "prebidonload", "prebidPageType", "isPrebidAllowed"];

// set GPT globals
var DisplayAdCmp = function DisplayAdCmp(_ref) {
  _ref.pageType;
    var adInventory = _ref.adInventory,
    targetDiv = _ref.targetDiv;
    _ref.targets;
    var eventList = _ref.eventList,
    isSRA = _ref.isSRA,
    blockGptLib = _ref.blockGptLib,
    blockPrebidLib = _ref.blockPrebidLib,
    prebidonload = _ref.prebidonload,
    prebidPageType = _ref.prebidPageType,
    isPrebidAllowed = _ref.isPrebidAllowed,
    props = _objectWithoutProperties(_ref, _excluded);
  var device = adInventory.device;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    gptReady = _useState2[0],
    setGptReady = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    pbjsReady = _useState4[0],
    setPbjsReady = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    pbjsFailed = _useState6[0],
    setPbjsFailed = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    gptInstance = _useState8[0],
    setgptInstance = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    pbjsInstance = _useState10[0],
    setpbjsInstance = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    slotList = _useState12[0],
    setSlotList = _useState12[1];

  // pbjs lib
  useEffect(function () {
    var _getUserCookiePrefere = getUserCookiePreferences(),
      isAdvertisingCookieBlocked = _getUserCookiePrefere.isAdvertisingCookieBlocked;
    if (!pbjsInstance && isPrebidAllowed && prebidPageType && !isAdvertisingCookieBlocked && !blockPrebidLib) {
      var instance = libInitLoader$1("//micro.rubiconproject.com/prebid/dynamic/12222.js?pagetype=" + prebidPageType, 'pbj');
      setpbjsInstance(instance);
    }
  }, [pbjsInstance, isPrebidAllowed, prebidPageType]);

  // gpt lib
  useEffect(function () {
    if (!gptInstance && !blockGptLib) {
      var instance = libInitLoader$1('//securepubads.g.doubleclick.net/tag/js/gpt.js', 'gpt');
      setgptInstance(instance);
    }
  }, [gptInstance, blockGptLib]);
  useEffect(function () {
    var _window;
    if (gptInstance) {
      initializeGlobals();
      setGptReady(waitForGpt);
    }
    if (blockGptLib) {
      initializeGlobals();
      setGptReady(waitForGpt);
    }
    if (pbjsInstance && isPrebidAllowed && (gptInstance || (_window = window) !== null && _window !== void 0 && _window.gtag)) {
      initPrebid();
      retry(isPbjsReady).then(function (isReady) {
        if (isReady) {
          setPbjsReady(isReady);
        }
      }).catch(function (error) {
        setPbjsFailed(true);
        console.log('prebid', error);
      });
    }
    if (blockPrebidLib && prebidonload) {
      initPrebid();
      retry(isPbjsReady).then(function (isReady) {
        if (isReady) {
          setPbjsReady(isReady);
        }
      }).catch(function (error) {
        setPbjsFailed(true);
        console.log('prebid', error);
      });
    }
  }, [gptInstance, pbjsInstance, blockGptLib, blockPrebidLib, isPrebidAllowed, prebidonload]);
  useMemo(function () {
    var getSlotKeys$1 = function getSlotKeys$1() {
      return new Promise(function ($return, $error) {
        var list;
        return Promise.resolve(getSlotKeys({
          device: device,
          variant: props.variant,
          setSlotList: setSlotList
        })).then(function ($await_1) {
          try {
            list = $await_1;
            return $return(list);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };
    getSlotKeys$1();
  }, [device, props.variant]);
  var getTagId = function getTagId(slotId) {
    var rndId = uuid();
    var dynamicTag = slotId + "-" + rndId;
    return dynamicTag;
  };
  var getDynamicId = useCallback(function () {
    return getTagId(targetDiv);
  }, [targetDiv]);
  var adId = useMemo(function () {
    return getDynamicId();
  }, [getDynamicId]);
  useEffect(function () {
    var isPrebidable = adInventory.isPrebid && isPrebidAllowed && pbjsReady;
    if (isPrebidable && !pbjsFailed) {
      createPrebidSlotFromInventory(Object.assign({
        adInventory: adInventory,
        gptReady: gptReady,
        eventList: eventList,
        slotList: slotList,
        isPrebidAllowed: isPrebidAllowed,
        adId: adId,
        isSRA: isSRA,
        pbjsReady: pbjsReady
      }, props));
    } else if (!isPrebidAllowed || pbjsFailed) {
      createSlotFromInventory(Object.assign({
        adInventory: adInventory,
        gptReady: gptReady,
        eventList: eventList,
        slotList: slotList,
        isPrebidAllowed: isPrebidAllowed,
        adId: adId,
        isSRA: isSRA,
        pbjsReady: pbjsReady
      }, props));
    }
  }, [adId, adInventory, eventList, gptReady, isPrebidAllowed, isSRA, pbjsReady, props, slotList, targetDiv, pbjsFailed]);
  useEffect(function () {
    if (eventList) {
      var _window2, _window2$gtag, _window2$gtag$cmd;
      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$gtag = _window2.gtag) === null || _window2$gtag === void 0 ? void 0 : (_window2$gtag$cmd = _window2$gtag.cmd) === null || _window2$gtag$cmd === void 0 ? void 0 : _window2$gtag$cmd.push(function () {
        registerEvents(eventList, props);
      });
    }
    return function () {
      if (eventList) {
        var _window3, _window3$gtag, _window3$gtag$cmd;
        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$gtag = _window3.gtag) === null || _window3$gtag === void 0 ? void 0 : (_window3$gtag$cmd = _window3$gtag.cmd) === null || _window3$gtag$cmd === void 0 ? void 0 : _window3$gtag$cmd.push(function () {
          unRegisterEvents(eventList, props);
        });
      }
      if (props.selfDestroy) {
        destroySlot$1(targetDiv);
      }
    };
    // eslint-disable-next-line zillow/react-hooks/exhaustive-deps
  }, []);
  function waitForGpt() {
    var isReady = isGPTtagReady();
    return Promise.resolve(isReady).then(document.dispatchEvent(new Event('gtagOnReady')));
  }
  if (!gptInstance && !gptReady && adId) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Slots$1, _extends({}, props, {
    targetDiv: adInventory.targetDiv || targetDiv,
    adId: adId
  }));
};
var version = "mst_" + pjson.version + "v";
var environment = process.env.NODE_ENV;
var DisplayAd = function DisplayAd(props) {
  var sentryScope = initMstSentryScope(SENTRY_PROJECT_NAME, SENTRY_DNS, environment, version, props.pageType);
  arcane$1.setSentryScope(sentryScope);
  return /*#__PURE__*/React.createElement(MstSentry, {
    sentryScope: sentryScope
  }, /*#__PURE__*/React.createElement(DisplayAdCmp, props));
};
var DisplayAd$1 = DisplayAd;
DisplayAd.propTypes = process.env.NODE_ENV !== "production" ? {
  adInventory: PropTypes.shape({
    adSizes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    position: PropTypes.string,
    pageType: PropTypes.string,
    brand: PropTypes.string,
    collapseAfterRequest: PropTypes.bool,
    collapseBeforeRequest: PropTypes.bool,
    targets: PropTypes.shape(),
    device: PropTypes.oneOf(['tablet', 'mobile', 'desktop']).isRequired,
    targetDiv: PropTypes.string.isRequired
  }).isRequired,
  pageType: PropTypes.string,
  isSRA: PropTypes.bool,
  /* if false, it will override isPrebid flag and display the ad normally */
  isPrebidAllowed: PropTypes.bool,
  targetDiv: PropTypes.string
} : {};
DisplayAd.defaultProps = {
  targetDiv: '',
  pageType: '',
  isSRA: false
};

var Advert = function Advert(props) {
  return /*#__PURE__*/React.createElement(DisplayAd$1, props);
};
var refreshSlot = refreshSlot$1,
  refreshDeferredSlot = refreshDeferredSlot$1,
  destroySlot = destroySlot$1,
  clearSlotTargeting = clearSlotTargeting$1;
var removeEventListener = removeEventListener$1;

export { Advert, clearSlotTargeting, destroySlot, refreshDeferredSlot, refreshSlot, removeEventListener };
